import React, { useMemo, useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import WidgetsGrid from "../../../components/_layout/WidgetsGrid";
import Page from "../../../components/_layout/Page";
import { hasPermsOnIndexesOrReceipts } from '../../../services/rolesSvc';
import useUserContext from '../../../hooks/useUserContext';
import useAPI from "../../../hooks/useAPI";
import useNavProject from "../../../hooks/useNavProject";

export default function PoliciesReport(){
  const api = useAPI();
  const {stratId} = useParams();
  const userCtx = useUserContext();
  const navProject = useNavProject();
  const history = useHistory();

  const [policy, setPolicy] = useState();

  // Определяем, находимся ли мы в архивном разделе
  const isArchiveRoute = useMemo(() => {
    return history.location.pathname.includes('/policies/archive');
  }, [history.location.pathname]);

  useEffect(async () => {
    const result = await api.get(`/mng/strategies/${stratId}`);
    navProject.setPolicyTitle(result.name);
    setPolicy(result);
  }, []);

  const widgets = useMemo(() => {
    // Для архивных политик
    if (isArchiveRoute) {
      return [
        {
          name: 'Вехи политики', 
          url: `/policies/archive/${stratId}/report/milestones`
        }
      ];
    }
    
    // Для обычных политик
    return [
      {
        name: 'Реестр отчётов', 
        url: `/policies/${stratId}/report/reports`
      },
      {
        name: `Унифицированные показатели проектов политики`, 
        url: `/policies/${stratId}/report/unified`, 
        show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId})
      },
      {
        name: 'Вехи политики', 
        url: `/policies/${stratId}/report/milestones`
      },
      {
        name: `Поступления от научной и иновационной деятельности`, 
        url: `/policies/${stratId}/report/receipts`
      }
    ];
  }, [stratId, isArchiveRoute]);

  return (
    <Page header="Отчет по политике" className="policies-page">
      <WidgetsGrid items={widgets.filter((w) => !w.show || w.show(userCtx.perms)) } />
    </Page>
  );
}
